import { Injectable } from '@angular/core';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { Router } from '@angular/router';
import { AuthService } from '../../auth';
import { TagService } from '../_services/tags.service';
import {
  FireTagSuccess,
  TagActionTypes,
  TagCreated,
  TagOnServerCreated,
  TagsActionToggleLoading,
  TagsPageCancelled,
  TagsPageLoaded,
  TagsPageRequested,
  TagsPageToggleLoading,
  ThrowTagError,
} from '../_actions/tag.actions';

@Injectable()
export class TagEffects {
  showPageLoadingDistpatcher = new TagsPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new TagsPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new TagsActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new TagsActionToggleLoading({ isLoading: false });

  @Effect()
  loadTagsPage$ = this.actions$.pipe(
    ofType<TagsPageRequested>(TagActionTypes.TagsPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.tag.findTags(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0] && response[0].error) {
            if (response[0].status === 401) {
              this.authService.logout();
              return new TagsPageCancelled();
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new TagsPageCancelled();
            } else {
              this.store.dispatch(new ThrowTagError({ error: response[0].error.error }));
              return new TagsPageCancelled();
            }
          } else {
            const result = response[0];
            return new TagsPageLoaded({
              tags: result.data,
              totalCount: result.count,
              page: response[1],
            });
          }
        }),
      );
    }),
  );

  @Effect()
  createTag$ = this.actions$.pipe(
    ofType<TagOnServerCreated>(TagActionTypes.TagOnServerCreated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.tag.createTag(payload.tag).pipe(
        catchError((error) => {
          return of(error);
        }),
        map((res) => {
          if (res && res.error) {
            return new ThrowTagError({ error: res.error });
          } else {
            this.store.dispatch(new FireTagSuccess({ action_type: TagActionTypes.TagCreated }));
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            return new TagCreated({ tag: res });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private tag: TagService,
    private store: Store<AppState>,
    private router: Router,
    private authService: AuthService,
  ) {}
}
